var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-container"},[_c('screenfull'),_c('div',{staticClass:"user-info"},[_c('span',{staticClass:"say-hi"},[_vm._v(_vm._s(_vm.author.name))]),_c('author')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }